// extracted by mini-css-extract-plugin
module.exports = {"links":"buttonLinks_links__Bulvc"};